import { useTranslation } from "react-i18next";
import config from "src/config";
import { DIAGNOSTIC_STEP_RESULTS_KEY } from "@/constants/diagnostics";
import { Button } from "@/ui";
import DiagnosticsSection from "../DiagnosticsSection";

const GetResults = () => {
  const { t } = useTranslation();

  const onClickRestartTest = () => {
    window.location.href = config.patient_url;
  };

  return (
    <DiagnosticsSection id={DIAGNOSTIC_STEP_RESULTS_KEY}>
      <div className="section-wrapper">
        <div className="section-content">
          <h2>{t('all_tests_passed')}</h2>
          <p>{t('all_tests_passed_description')}</p>
          <Button onClick={onClickRestartTest}>{t('return_to_home')}</Button>
        </div>
        <div className="section-image">
          <img src="/images/all-tests-passed.webp" alt={t('all_tests_passed')} />
        </div>
      </div>
    </DiagnosticsSection>
  );
};

export default GetResults;